<nav class="doctor-nav" *ngIf="(user$ | async)?.isDoctor" aria-label="Clinician navigation">
  <p class="doctor-nav__eyebrow page__eyebrow">Clinician</p>
  <ul class="doctor-nav__list">
    <li *ngFor="let item of items">
      <a
        class="doctor-nav__link"
        [routerLink]="item.link"
        [class.doctor-nav__link--active]="isActive(item)"
      >
        <i class="pi {{ item.icon }}" aria-hidden="true"></i>
        <span>{{ item.label }}</span>
      </a>
    </li>
  </ul>
</nav>
